export default __webpack_public_path__ + "static/media/kinaesthetic-empathy.fdf23d31.png";